/**
 * Auth User Reducers
 */
import React from 'react';
import {NotificationManager} from 'react-notifications';
import {
    LOGIN_USER,
    LOGIN_USER_FAILURE,
    LOGIN_USER_SUCCESS,
    LOGOUT_USER,
    LOGOUT_USER_FAILURE,
    LOGOUT_USER_SUCCESS,
    SET_REGISTRATION_EMAIL,
    SIGNUP_USER,
    SIGNUP_USER_FAILURE,
    SIGNUP_USER_SUCCESS,
} from '../actions/types';
import {accessTokenLocalStorageKey} from '../constants';
import storage from '../fetchApi/storage';
import IntlMessage from '../util/IntlMessage.tsx';

/**
 * initial auth user
 */
const INIT_STATE = {
    isLoggedIn: !!(storage.load(accessTokenLocalStorageKey)),
    loading: false,
    registrationEmail: '',
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER:
            return {...state, loading: true};

        case LOGIN_USER_SUCCESS:
            return {...state, loading: false, isLoggedIn: true};

        case LOGIN_USER_FAILURE:
            NotificationManager.error(action.payload);
            return {...state, loading: false};

        case LOGOUT_USER:
            return {...state};

        case LOGOUT_USER_SUCCESS:
            NotificationManager.success(<IntlMessage id="auth.actions.success_logout" />);
            return {...state, isLoggedIn: false};

        case LOGOUT_USER_FAILURE:
            return {...state};

        case SIGNUP_USER:
            return {...state, loading: true};

        case SIGNUP_USER_SUCCESS:
            return {...state, loading: false, isLoggedIn: true};

        case SIGNUP_USER_FAILURE:
            NotificationManager.error(action.payload);
            return {...state, loading: false};
        case SET_REGISTRATION_EMAIL:
            return {...state, registrationEmail: action.payload};
        default:
            return {...state};
    }
};
